import React, { FC } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { PillButton } from "../ui";
import { SUPPORT_PORTAL_URL } from "../../data/installation-guides";
import { tokens } from "../../styles/tokens";

const SupportCard: FC = () => (
  <Box
    sx={{
      bgcolor: tokens.color.ink,
      borderRadius: `${tokens.radius.card}px`,
      p: { mobile: 3, tablet: 4 },
      display: "flex",
      flexWrap: "wrap",
      gap: 2,
      alignItems: "center",
      justifyContent: "space-between",
    }}
  >
    <Box>
      <Typography variant="h4" sx={{ color: "#FFFFFF", mb: 0.5 }}>
        Need help with something else?
      </Typography>
      <Typography variant="body1" sx={{ color: "rgba(255,255,255,0.72)" }}>
        How-to guides, manuals, firmware notes, video tutorials and support
        tickets are all on the Artome support portal.
      </Typography>
    </Box>

    <PillButton
      tone="amber"
      component="a"
      href={SUPPORT_PORTAL_URL}
      target="_blank"
      rel="noopener noreferrer"
      endIcon={<OpenInNewIcon sx={{ fontSize: 16 }} />}
    >
      Artome support
    </PillButton>
  </Box>
);

export default SupportCard;
